import 'proxy-polyfill'

// hack for IE11 which doesn't support Proxy
// (can't be polyfilled for this use-case)

import { createDomMotionComponent as custom } from 'framer-motion/dist/es'

export {
  createDomMotionComponent,
  m,
  AnimatePresence,
  AnimateSharedLayout,
  AnimationFeature,
  DragFeature,
  ExitFeature,
  GesturesFeature,
  AnimateLayoutFeature,
  useMotionValue,
  useMotionTemplate,
  MotionValue,
  motionValue,
  resolveMotionValue,
  useTransform,
  useSpring,
  useVelocity,
  useElementScroll,
  useViewportScroll,
  useReducedMotion,
  animationControls,
  useAnimation,
  animate,
  animateVisualElement,
  useTapGesture,
  usePanGesture,
  useGestures,
  useCycle,
  transform,
  isValidMotionProp,
  usePresence,
  useIsPresent,
  useDragControls,
  DragControls,
  useDomEvent,
  createMotionComponent,
  addScaleCorrection,
  createCrossfader,
  visualElement,
  MotionConfig,
  MotionConfigContext,
  PresenceContext,
  LayoutGroupContext,
  useDeprecatedAnimatedState,
  useDeprecatedInvertedScale
} from 'framer-motion/dist/es'

type Custom = Record<
  'div' | 'span' | 'section' | 'ul' | 'li',
  ReturnType<typeof custom>
>

export const motion: typeof custom & Custom = (...args) => custom(...args)
motion.custom = custom

// add factories
// used either by us or by chakra-ui
for (const k of ['div', 'span', 'section', 'ul', 'li']) {
  motion[k] = custom(k as any)
}
